(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('RegisterModalPreApprovedController', RegisterModalPreApprovedController)

    RegisterModalPreApprovedController.$inject = ['$uibModalInstance', 'preApprovedItem', 'sellers', 'VirtualFairService', '$rootScope', 'LanguagesService'];

    function RegisterModalPreApprovedController($uibModalInstance, preApprovedItem, sellers, VirtualFairService, $rootScope, LanguagesService) {
        var vm = this;

        vm.preApprovedItem = preApprovedItem;
        vm.sellers         = sellers;
        vm.languageList    = [];
        vm.languageSelected= {};
        vm.seller          = '';
        vm.registered      = '';
        vm.query           = [];
        vm.ok              = ok;
        vm.cancel          = cancel;
        vm.update          = update;
        vm.selectLanguages = selectLanguages;

        activate();

        function activate() {
            vm.seller = {id:vm.preApprovedItem.seller_id, name:vm.preApprovedItem.seller_name};
            vm.registered = preApprovedItem.registered;
            vm.selectLanguages();
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function selectLanguages() {
            LanguagesService.getAllLanguages().then(function(response){
                vm.languageList = response.data;
            }).catch(function(err) {
            });
        }

        function update() {
            vm.query['registered']          = vm.registered;
            vm.query['seller']              = vm.seller.id;
            vm.query['observation']         = vm.preApprovedItem.admin_observation;
            vm.query['pre_register_cod']    = vm.preApprovedItem.id;

            VirtualFairService.updatePreApproved(vm.query).then(function(response){
                alertify.notify(response.data, 'success', 3);
                vm.preApprovedItem.seller_name = vm.seller.name;

            }).catch(function(err) {
                alertify.notify(err, 'danger', 3);
            });
        }

    }

})();